export default __webpack_public_path__ + "static/media/contentimg.543f5082.jpg";